//
import Keycloak from 'keycloak-js';
import { logger } from 'app/shared/util/logger';

const keycloak = new Keycloak({
  // url: 'https://login.scoringjoe.com',  <- your company's Keycloak URL
  url: `${process.env.KEYCLOAK_URL}${process.env.KEYCLOAK_PORT && process.env.KEYCLOAK_PORT !== '' ? `:${process.env.KEYCLOAK_PORT}` : ''}`, // <- your company's Keycloak URL
  realm: 'public', // <- check in Keycloak Admin dashboard
  clientId: 'scoring-joe', // <- the Client ID from previous step
});

// Low-level lifecycle logs
keycloak.onAuthError = error => logger.error('[KC:onAuthError]', error);
keycloak.onAuthRefreshError = () => logger.error('[KC:onAuthRefreshError]');
keycloak.onTokenExpired = () => {
  logger.warn('[KC:onTokenExpired]');
  keycloak.updateToken(60).catch(err => {
    logger.error('[KC:updateToken error after expiry]', err);
    keycloak.logout();
  });
};

export default keycloak;
